import { Suspense, lazy } from 'react'

import type { RichTextEditorProps } from './rich-text-editor'
import { m } from '@/lib/paraglide/messages'

// TipTap + ProseMirror (~270 kB) chỉ tải khi màn có ô soạn nội dung mở ra,
// không nằm trong chunk entry của mọi người dùng ERP.
/** Tải chunk trình soạn (chạy lại không tải lại); dùng để nạp trước, vd trong test. */
export const loadRichTextEditor = () => import('./rich-text-editor')

const Editor = lazy(() =>
    loadRichTextEditor().then((mod) => ({
        default: mod.RichTextEditor,
    })),
)

/** Trình soạn nội dung dùng chung (tải lười); props như RichTextEditorProps. */
export function RichTextEditor(props: RichTextEditorProps) {
    return (
        <Suspense
            fallback={
                <div
                    className="flex min-h-56 items-center justify-center rounded-md border bg-muted/30 text-sm text-muted-foreground"
                    aria-busy="true"
                >
                    {m.richText_loading()}
                </div>
            }
        >
            <Editor {...props} />
        </Suspense>
    )
}
